import { useIntl } from 'react-intl';
import Button from 'client/components/aria/Button/Button';
import TextInput from 'client/components/aria/SearchField/SearchField';
import styles from './WorkspaceSearch.module.scss';
import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import MyLocationButton from 'client/components/MyLocationButton/MyLocationButton';
import { MAP_PAGE } from 'client/utils/routes/routeConstants';
import { useNavigate } from 'react-router';

const WorkspaceSearch = ({ onClick, onChange, searchDisabled, ...props }) => {
    const intl = useIntl();
    const navigate = useNavigate();

    const handleSearchKeypress = evt => {
        if (searchDisabled) {
            return;
        }
        const { keyCode, key } = evt;
        if ((keyCode === 13 || key === 'Enter')) {
            onClick();
        }
    };

    return (<div className = {styles.flex}>
        <TextInput className = {styles.input}
            id="workspace.map.search"
            placeholder= {intl.formatMessage({ id: 'workspace.map.search.placeholder' })}
            onChange={onChange}
            aria-label={intl.formatMessage({ id: 'workspace.map.search.textinput' })}
            data-testid={props['data-testid'] ? props['data-testid'] + '.input' : null}
            onKeyDown = {handleSearchKeypress}
        />
        <div className={styles.tabIndexFix}>
            <Button className = {styles.button}
                data-testid="workspace.map.search.button"
                aria-label={intl.formatMessage({ id: 'workspace.map.search.button' })}
                isDisabled={ searchDisabled }
                onPress={onClick}
            >
                <svg className="govuk-button_start-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.5"
                    height="19"
                    viewBox="0 0 33 40"
                    aria-hidden="true"
                    focusable="false">
                    <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z"/>
                </svg>
            </Button>
            <MyLocationButton
                labelI18nKey={'workspace.map.search.locateMe'}
                className={styles.geolocationButton}
                onPress={() => {
                    navigate(MAP_PAGE);
                }}/>
        </div>
    </div>);
};

WorkspaceSearch.propTypes = {
    ...defaultAriaProps,
    input: PropTypes.string,
    button: PropTypes.func
};

export default WorkspaceSearch;
